import { Input, InputProps } from "@caspeco/casper-ui-library";
import { debounce } from "lodash";
import { ChangeEvent, RefObject, useRef, useState } from "react";

interface DelayedInputProps extends InputProps {
	delay: number; //miliseconds
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	ref?: RefObject<HTMLInputElement | null>;
}

const DelayInput = ({ delay, onChange, ref, ...props }: DelayedInputProps) => {
	const [value, setValue] = useState(props.value);

	const debouncedSearch = useRef(
		debounce((event) => {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
			onChange(event);
		}, delay),
	).current;

	const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
		setValue(event.target.value);
		debouncedSearch(event);
	};

	return <Input ref={ref} {...props} value={value} onChange={handleOnChange} />;
};

export default DelayInput;
